import { useNavigate } from "react-router-dom";

export default function CancelPage() {
  const navigate = useNavigate();
  return (
    <div className="cancel-container" style={{ textAlign: "center", marginTop: 60 }}>
      <h2>❌ Payment Cancelled</h2>
      <p>Your upgrade was not completed. You can try again or return to the home page.</p>
      <button
        style={{ marginTop: 24, marginRight: 12, padding: "12px 32px", borderRadius: 8, background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: 18, border: "none", cursor: "pointer" }}
        onClick={() => navigate("/settings")}
      >
        Try Again
      </button>
      <button
        style={{ marginTop: 24, padding: "12px 32px", borderRadius: 8, background: "#1e3a8a", color: "#fff", fontWeight: "bold", fontSize: 18, border: "none", cursor: "pointer" }}
        onClick={() => navigate("/")}
      >
        Go to Home
      </button>
    </div>
  );
}
